import { render, staticRenderFns } from "./card-article.vue?vue&type=template&id=2b204300&scoped=true&"
import script from "./card-article.vue?vue&type=script&lang=js&"
export * from "./card-article.vue?vue&type=script&lang=js&"
import style0 from "./card-article.vue?vue&type=style&index=0&id=2b204300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b204300",
  null
  
)

export default component.exports